<template>
  <label
    class="w-full flex items-center mt-4 h-11   md:mt-0 border border-gray-300 bg-white dark:bg-gray-700  rounded-lg text-black dark:text-white relative focus:border-red-400"
    :class="[inputClass, { 'md:w-3/12': !isFull && !inputClass }]"
    style="min-width: 195px;"
  >
    <i class="fas fa-search text-gray-400 dark:text-gray-200 m-0 w-1/12 left-3 right-2 absolute text-md"></i>
    <input
      @keypress.enter="$emit('searcing', val)"
      v-model="val"
      type="search"
      style="font-size: 15px;"
      class="w-full pl-9 pr-2 text-gray-500 bg-transparent focus:ring-2 focus:ring-gray-300 focus:border-blue-400 focus:outline-none rounded-lg hover:outline-0 h-full "
      :placeholder="placeholder ? placeholder : 'Aramak için yazın...'"
    />
  </label>
</template>

<script>
export default {
  name: "search-input",
  props: ["value", "isFull", "inputClass", "placeholder"],
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      val: "",
    };
  },
  created() {
    this.val = this.value;
  },
  watch: {
    value(val) {
      this.val = val;
    },
    val(val) {
      this.$emit("change", val);
    },
  },
};
</script>

<style></style>
